import { render, staticRenderFns } from "./DFFile_URL2.vue?vue&type=template&id=1f557ad2&"
import script from "./DFFile_URL2.vue?vue&type=script&lang=js&"
export * from "./DFFile_URL2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports